import React from "react";
import PropTypes from "prop-types";
import { Button, Dialog, DialogTitle, Divider, Typography } from "@material-ui/core";

import {
  trackEventKeepRenewalConfirmation,
  trackEventConfirmRenewalOff,
  trackEventCloseConfirmRenewalModal,
} from "utils/gAnalyticsUtils";
import SpinningCloseButton from "components/SpinningCloseButton";
import { appRoutes } from "routes";
import { useUsers, useNotifications, useRouter } from "hooks";
import UserPresenter from "presenters/UserPresenter";
import SubscriptionPresenter from "presenters/SubscriptionPresenter";
import gif from "assets/images/cancellation/cancellation.gif";

import useStyles from "./useStyles";

const TurnOffRenewalModal = (props) => {
  const { onClose } = props;
  const { push } = useRouter();
  const classes = useStyles();
  const { addSuccessNotification } = useNotifications();
  const { currentUser, deactivateSubscription } = useUsers();
  const subscription = UserPresenter.activeSubscription(currentUser);

  const handleCloseModal = () => {
    trackEventCloseConfirmRenewalModal();
    onClose();
  };

  const handleKeepOn = () => {
    trackEventKeepRenewalConfirmation();
    onClose();
    push(appRoutes.subscriptionDetailsPath());
  };

  const handleTurnOffRenewal = () => {
    const subId = SubscriptionPresenter.id(subscription);
    const type = SubscriptionPresenter.paymentProviderName(subscription);
    const params = {
      data: {
        type: "cancellations",
      },
    };

    deactivateSubscription(subId, type, params).then(() => {
      trackEventConfirmRenewalOff();
      addSuccessNotification("Auto-renew Disabled");
      onClose();
      push(appRoutes.subscriptionDetailsPath());
    });
  };

  return (
    <Dialog
      open
      scroll="body"
      onBackdropClick={() => handleCloseModal()}
      classes={{ root: classes.root }}
      PaperProps={{ classes: { root: classes.paper } }}
    >
      <SpinningCloseButton onClick={handleCloseModal} />

      <DialogTitle disableTypography classes={{ root: classes.title }}>
        Membership Renewal
      </DialogTitle>

      <Typography>We will be sorry to see you go!</Typography>

      <img src={gif} alt="crying" className={classes.image} />

      <Button color="primary" className={classes.action} onClick={handleTurnOffRenewal}>
        Turn Renewal Off
      </Button>

      <Typography>Your membership will be active until it expires.</Typography>

      <Divider className={classes.divider} />

      <Typography>Not quite sure?</Typography>

      <Button variant="contained" color="secondary" className={classes.button} onClick={handleKeepOn}>
        Keep Renewal On
      </Button>
    </Dialog>
  );
};

TurnOffRenewalModal.propTypes = {
  onClose: PropTypes.func.isRequired,
};

export default TurnOffRenewalModal;
